module.exports = ".card {\n    max-width: 23rem;\n}\n\n"